module.exports = __webpack_public_path__ + "img/sway-logo.e8d9d491.png";